/**
 * Build a CRUD permission from a single "may mutate" predicate. Read is always granted;
 * create / update / delete follow `canMutate` and are force-disabled when `readOnly` is set —
 * e.g. an admin inspecting another user's data may look but not touch.
 *
 * @param canMutate Whether the user may perform write actions at all.
 * @param options.readOnly When true, all writes are disabled regardless of `canMutate`.
 */
export const toPermission = (canMutate, options) => {
    const canWrite = canMutate && !options?.readOnly;
    return { create: canWrite, read: true, update: canWrite, delete: canWrite };
};
